<template>
  <div class="static-page">
    <div class="basic">
      <div class="page-title bold">
        身体健康情况承诺书
      </div>
      <p class="page-content">
        本人承诺身体健康状况正常，没有不宜从事一线建筑安装类工种的疾病。
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'aboutUs',
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
  .bold{
    font-weight: bold;
  }

  .static-page {
    height: 100%;
    @include add_size($font_size_16);
    text-align: justify;
  }

  .basic {
    height: 100vh;
    padding-bottom: 40px;
  }

  .page-title {
    margin: 10px 0;
    text-align: center;
  }

  .page-content {
    text-indent: 2em;
    padding-top: 5px;
  }

</style>
